import {Checkbox} from '/ui/components/checkbox/checkbox';
import {Tooltip} from '/ui/components/tooltip/tooltip';

import * as styles from '/src/com/yext/listingslaunchstorm/js/enterprise/skipsetup/skipsetup.module.scss';

export function SkipSetup({skipSetup, disabled, onClick, tooltipText}) {
  return <div className={styles.skipSetup}>
    <Tooltip
      unclearText={
        <Checkbox
          checked={skipSetup}
          disabled={disabled}
          value={skipSetup}
          onChange={onClick}
          label={yext.msg('Skip Setup')}>
        </Checkbox>
      }
      tooltipText={tooltipText}
    />
  </div>;
}
